export function isEmailAuthAvailable(features) {
    return features?.studioLogin?.email?.enabled === true;
}

export function isGoogleAuthAvailable(features) {
    return features?.studioLogin?.google?.enabled === true;
}

export function isGithubAuthAvailable(features) {
    return features?.github?.enabled === true && features?.studioLogin?.github?.enabled === true;
}

export function isAnyAuthAvailable(features) {
    return isEmailAuthAvailable(features) || isGoogleAuthAvailable(features) || isGithubAuthAvailable(features);
}